
import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";


export class FrendsExpressionLexer extends antlr.Lexer {
    public static readonly EACH_OPEN = 1;
    public static readonly END_EACH_TAG = 2;
    public static readonly IF_OPEN = 3;
    public static readonly ELSE_IF_OPEN = 4;
    public static readonly ELSE_TAG = 5;
    public static readonly END_IF_TAG = 6;
    public static readonly OPEN_BRACES = 7;
    public static readonly STRING = 8;
    public static readonly CLOSE_BRACES = 9;
    public static readonly VAR_REF = 10;
    public static readonly TRIGGER_REF = 11;
    public static readonly PROCESS_REF = 12;
    public static readonly ENV_REF_START = 13;
    public static readonly CERT_REF_START = 14;
    public static readonly RESULT_NODE_REF = 15;
    public static readonly RESULT_REF = 16;
    public static readonly THIS_REF = 17;
    public static readonly INDEX_REF = 18;
    public static readonly SOURCE_REF = 19;
    public static readonly CS_TEXT = 20;
    public static readonly LAST_SEGMENT_VALUE = 21;
    public static readonly CSHARP_MODE = 1;
    public static readonly CSHARP_MODE_NO_EXIT = 2;
    public static readonly READ_LAST_SEGMENT = 3;
    public static readonly READ_LAST_SEGMENT_NO_EXIT = 4;

    public static readonly channelNames = [
        "DEFAULT_TOKEN_CHANNEL", "HIDDEN"
    ];

    public static readonly literalNames = [
        null, null, null, null, null, null, null, "'{{'", null, "'}}'"
    ];

    public static readonly symbolicNames = [
        null, "EACH_OPEN", "END_EACH_TAG", "IF_OPEN", "ELSE_IF_OPEN", "ELSE_TAG", 
        "END_IF_TAG", "OPEN_BRACES", "STRING", "CLOSE_BRACES", "VAR_REF", 
        "TRIGGER_REF", "PROCESS_REF", "ENV_REF_START", "CERT_REF_START", 
        "RESULT_NODE_REF", "RESULT_REF", "THIS_REF", "INDEX_REF", "SOURCE_REF", 
        "CS_TEXT", "LAST_SEGMENT_VALUE"
    ];

    public static readonly modeNames = [
        "DEFAULT_MODE", "CSHARP_MODE", "CSHARP_MODE_NO_EXIT", "READ_LAST_SEGMENT", 
        "READ_LAST_SEGMENT_NO_EXIT",
    ];

    public static readonly ruleNames = [
        "EACH_OPEN", "END_EACH_TAG", "IF_OPEN", "ELSE_IF_OPEN", "ELSE_TAG", 
        "END_IF_TAG", "OPEN_BRACES", "STRING", "CLOSE_BRACES", "VAR_REF", 
        "TRIGGER_REF", "PROCESS_REF", "ENV_REF_START", "CERT_REF_START", 
        "RESULT_NODE_REF", "RESULT_REF", "THIS_REF", "INDEX_REF", "SOURCE_REF", 
        "CS_TEXT", "VAR_REF_NO_EXIT", "TRIGGER_REF_NO_EXIT", "PROCESS_REF_NO_EXIT", 
        "ENV_REF_START_NO_EXIT", "CERT_REF_START_NO_EXIT", "RESULT_NODE_REF_NO_EXIT", 
        "RESULT_REF_NO_EXIT", "THIS_REF_NO_EXIT", "INDEX_REF_NO_EXIT", "SOURCE_REF_NO_EXIT", 
        "CS_TEXT_NO_EXIT", "CLOSE_BRACES_IN_LAST_SEGMENT", "FUNCTION_CALL", 
        "LAST_SEGMENT_VALUE", "NOT_SEGMENT", "FUNCTION_CALL_NO_EXIT", "LAST_SEGMENT_VALUE_NO_EXIT", 
        "NOT_SEGMENT_NO_EXIT", "ID_CHAR", "WS",
    ];


    public constructor(input: antlr.CharStream) {
        super(input);
        this.interpreter = new antlr.LexerATNSimulator(this, FrendsExpressionLexer._ATN, FrendsExpressionLexer.decisionsToDFA, new antlr.PredictionContextCache());
    }

    public get grammarFileName(): string { return "FrendsExpressionLexer.g4"; }

    public get literalNames(): (string | null)[] { return FrendsExpressionLexer.literalNames; }
    public get symbolicNames(): (string | null)[] { return FrendsExpressionLexer.symbolicNames; }
    public get ruleNames(): string[] { return FrendsExpressionLexer.ruleNames; }

    public get serializedATN(): number[] { return FrendsExpressionLexer._serializedATN; }

    public get channelNames(): string[] { return FrendsExpressionLexer.channelNames; }

    public get modeNames(): string[] { return FrendsExpressionLexer.modeNames; }

    public static readonly _serializedATN: number[] = [
        4,0,21,567,6,-1,6,-1,6,-1,6,-1,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,
        7,3,2,4,7,4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,
        11,7,11,2,12,7,12,2,13,7,13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,
        17,2,18,7,18,2,19,7,19,2,20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,
        24,7,24,2,25,7,25,2,26,7,26,2,27,7,27,2,28,7,28,2,29,7,29,2,30,7,
        30,2,31,7,31,2,32,7,32,2,33,7,33,2,34,7,34,2,35,7,35,2,36,7,36,2,
        37,7,37,2,38,7,38,2,39,7,39,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,
        1,0,1,0,1,0,1,0,1,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
        1,1,1,1,1,1,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,3,
        1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,
        1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,5,1,5,1,5,
        1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,6,1,6,1,6,1,6,1,6,1,7,1,7,
        1,7,4,7,176,8,7,11,7,12,7,177,1,7,3,7,181,8,7,1,8,1,8,1,8,1,8,1,
        8,1,9,1,9,1,9,1,9,1,9,1,9,1,9,4,9,195,8,9,11,9,12,9,196,5,9,199,
        8,9,10,9,12,9,202,9,9,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,
        10,1,10,1,10,4,10,215,8,10,11,10,12,10,216,3,10,219,8,10,1,11,1,
        11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,4,11,232,8,11,11,
        11,12,11,233,3,11,236,8,11,1,12,1,12,1,12,1,12,1,12,1,12,1,12,4,
        12,245,8,12,11,12,12,12,246,1,12,1,12,1,13,1,13,1,13,1,13,1,13,1,
        13,1,13,1,13,4,13,259,8,13,11,13,12,13,260,1,13,1,13,1,14,1,14,1,
        14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,5,14,275,8,14,10,14,12,14,
        278,9,14,1,14,1,14,1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,1,15,
        1,15,5,15,292,8,15,10,15,12,15,295,9,15,1,16,1,16,1,16,1,16,1,16,
        1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,18,1,18,1,18,1,18,1,18,1,18,
        1,18,1,18,1,18,1,18,4,18,319,8,18,11,18,12,18,320,5,18,323,8,18,
        10,18,12,18,326,9,18,1,19,4,19,329,8,19,11,19,12,19,330,1,19,3,19,
        334,8,19,1,20,1,20,1,20,1,20,1,20,1,20,1,20,4,20,343,8,20,11,20,
        12,20,344,5,20,347,8,20,10,20,12,20,350,9,20,1,20,1,20,1,21,1,21,
        1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,1,21,4,21,365,8,21,11,21,
        12,21,366,3,21,369,8,21,1,21,1,21,1,22,1,22,1,22,1,22,1,22,1,22,
        1,22,1,22,1,22,1,22,1,22,4,22,384,8,22,11,22,12,22,385,3,22,388,
        8,22,1,22,1,22,1,23,1,23,1,23,1,23,1,23,1,23,1,23,4,23,399,8,23,
        11,23,12,23,400,1,23,1,23,1,23,1,24,1,24,1,24,1,24,1,24,1,24,1,24,
        1,24,4,24,414,8,24,11,24,12,24,415,1,24,1,24,1,24,1,25,1,25,1,25,
        1,25,1,25,1,25,1,25,1,25,1,25,1,25,5,25,431,8,25,10,25,12,25,434,
        9,25,1,25,1,25,1,25,1,25,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,
        1,26,1,26,5,26,450,8,26,10,26,12,26,453,9,26,1,26,1,26,1,27,1,27,
        1,27,1,27,1,27,1,27,1,27,1,28,1,28,1,28,1,28,1,28,1,28,1,28,1,28,
        1,28,1,29,1,29,1,29,1,29,1,29,1,29,1,29,1,29,1,29,1,29,4,29,483,
        8,29,11,29,12,29,484,5,29,487,8,29,10,29,12,29,490,9,29,1,29,1,29,
        1,30,4,30,495,8,30,11,30,12,30,496,1,30,3,30,500,8,30,1,30,1,30,
        1,31,1,31,1,31,1,31,1,31,1,31,1,31,1,32,1,32,4,32,513,8,32,11,32,
        12,32,514,1,32,1,32,1,32,1,32,1,32,1,33,1,33,4,33,524,8,33,11,33,
        12,33,525,1,33,1,33,1,34,1,34,1,34,1,34,1,34,1,35,1,35,4,35,537,
        8,35,11,35,12,35,538,1,35,1,35,1,35,1,35,1,35,1,36,1,36,4,36,548,
        8,36,11,36,12,36,549,1,36,1,36,1,36,1,37,1,37,1,37,1,37,1,37,1,38,
        1,38,1,39,5,39,563,8,39,10,39,12,39,566,9,39,0,0,40,5,1,7,2,9,3,
        11,4,13,5,15,6,17,7,19,8,21,9,23,10,25,11,27,12,29,13,31,14,33,15,
        35,16,37,17,39,18,41,19,43,20,45,0,47,0,49,0,51,0,53,0,55,0,57,0,
        59,0,61,0,63,0,65,0,67,0,69,0,71,21,73,0,75,0,77,0,79,0,81,0,83,
        0,5,0,1,2,3,4,24,2,0,69,69,101,101,2,0,65,65,97,97,2,0,67,67,99,
        99,2,0,72,72,104,104,2,0,73,73,105,105,2,0,70,70,102,102,2,0,76,
        76,108,108,2,0,83,83,115,115,1,0,123,123,2,0,86,86,118,118,2,0,82,
        82,114,114,2,0,84,84,116,116,2,0,71,71,103,103,2,0,80,80,112,112,
        2,0,79,79,111,111,2,0,78,78,110,110,2,0,85,85,117,117,1,0,93,93,
        2,0,68,68,100,100,2,0,88,88,120,120,5,0,35,35,64,64,84,84,116,116,
        125,125,4,0,35,35,64,64,84,84,116,116,8,0,48,57,65,90,95,95,97,122,
        196,197,214,214,228,229,246,246,3,0,9,10,13,13,32,32,596,0,5,1,0,
        0,0,0,7,1,0,0,0,0,9,1,0,0,0,0,11,1,0,0,0,0,13,1,0,0,0,0,15,1,0,0,
        0,0,17,1,0,0,0,0,19,1,0,0,0,1,21,1,0,0,0,1,23,1,0,0,0,1,25,1,0,0,
        0,1,27,1,0,0,0,1,29,1,0,0,0,1,31,1,0,0,0,1,33,1,0,0,0,1,35,1,0,0,
        0,1,37,1,0,0,0,1,39,1,0,0,0,1,41,1,0,0,0,1,43,1,0,0,0,2,45,1,0,0,
        0,2,47,1,0,0,0,2,49,1,0,0,0,2,51,1,0,0,0,2,53,1,0,0,0,2,55,1,0,0,
        0,2,57,1,0,0,0,2,59,1,0,0,0,2,61,1,0,0,0,2,63,1,0,0,0,2,65,1,0,0,
        0,3,67,1,0,0,0,3,69,1,0,0,0,3,71,1,0,0,0,3,73,1,0,0,0,4,75,1,0,0,
        0,4,77,1,0,0,0,4,79,1,0,0,0,5,85,1,0,0,0,7,99,1,0,0,0,9,113,1,0,
        0,0,11,125,1,0,0,0,13,142,1,0,0,0,15,155,1,0,0,0,17,167,1,0,0,0,
        19,180,1,0,0,0,21,182,1,0,0,0,23,187,1,0,0,0,25,203,1,0,0,0,27,220,
        1,0,0,0,29,237,1,0,0,0,31,250,1,0,0,0,33,264,1,0,0,0,35,281,1,0,
        0,0,37,296,1,0,0,0,39,301,1,0,0,0,41,308,1,0,0,0,43,333,1,0,0,0,
        45,335,1,0,0,0,47,353,1,0,0,0,49,372,1,0,0,0,51,391,1,0,0,0,53,405,
        1,0,0,0,55,420,1,0,0,0,57,439,1,0,0,0,59,456,1,0,0,0,61,463,1,0,
        0,0,63,472,1,0,0,0,65,499,1,0,0,0,67,503,1,0,0,0,69,510,1,0,0,0,
        71,521,1,0,0,0,73,529,1,0,0,0,75,534,1,0,0,0,77,545,1,0,0,0,79,554,
        1,0,0,0,81,559,1,0,0,0,83,564,1,0,0,0,85,86,5,123,0,0,86,87,5,123,
        0,0,87,88,1,0,0,0,88,89,3,83,39,0,89,90,5,35,0,0,90,91,7,0,0,0,91,
        92,7,1,0,0,92,93,7,2,0,0,93,94,7,3,0,0,94,95,1,0,0,0,95,96,3,83,
        39,0,96,97,1,0,0,0,97,98,6,0,0,0,98,6,1,0,0,0,99,100,5,123,0,0,100,
        101,5,123,0,0,101,102,1,0,0,0,102,103,3,83,39,0,103,104,5,47,0,0,
        104,105,7,0,0,0,105,106,7,1,0,0,106,107,7,2,0,0,107,108,7,3,0,0,
        108,109,1,0,0,0,109,110,3,83,39,0,110,111,5,125,0,0,111,112,5,125,
        0,0,112,8,1,0,0,0,113,114,5,123,0,0,114,115,5,123,0,0,115,116,1,
        0,0,0,116,117,3,83,39,0,117,118,5,35,0,0,118,119,7,4,0,0,119,120,
        7,5,0,0,120,121,1,0,0,0,121,122,3,83,39,0,122,123,1,0,0,0,123,124,
        6,2,0,0,124,10,1,0,0,0,125,126,5,123,0,0,126,127,5,123,0,0,127,128,
        1,0,0,0,128,129,3,83,39,0,129,130,7,0,0,0,130,131,7,6,0,0,131,132,
        7,7,0,0,132,133,7,0,0,0,133,134,1,0,0,0,134,135,3,83,39,0,135,136,
        7,4,0,0,136,137,7,5,0,0,137,138,1,0,0,0,138,139,3,83,39,0,139,140,
        1,0,0,0,140,141,6,3,0,0,141,12,1,0,0,0,142,143,5,123,0,0,143,144,
        5,123,0,0,144,145,1,0,0,0,145,146,3,83,39,0,146,147,7,0,0,0,147,
        148,7,6,0,0,148,149,7,7,0,0,149,150,7,0,0,0,150,151,1,0,0,0,151,
        152,3,83,39,0,152,153,5,125,0,0,153,154,5,125,0,0,154,14,1,0,0,0,
        155,156,5,123,0,0,156,157,5,123,0,0,157,158,1,0,0,0,158,159,3,83,
        39,0,159,160,5,47,0,0,160,161,7,4,0,0,161,162,7,5,0,0,162,163,1,
        0,0,0,163,164,3,83,39,0,164,165,5,125,0,0,165,166,5,125,0,0,166,
        16,1,0,0,0,167,168,5,123,0,0,168,169,5,123,0,0,169,170,1,0,0,0,170,
        171,6,6,0,0,171,18,1,0,0,0,172,176,8,8,0,0,173,174,5,123,0,0,174,
        176,8,8,0,0,175,172,1,0,0,0,175,173,1,0,0,0,176,177,1,0,0,0,177,
        175,1,0,0,0,177,178,1,0,0,0,178,181,1,0,0,0,179,181,5,123,0,0,180,
        175,1,0,0,0,180,179,1,0,0,0,181,20,1,0,0,0,182,183,5,125,0,0,183,
        184,5,125,0,0,184,185,1,0,0,0,185,186,6,8,1,0,186,22,1,0,0,0,187,
        188,5,35,0,0,188,189,7,9,0,0,189,190,7,1,0,0,190,191,7,10,0,0,191,
        200,1,0,0,0,192,194,5,46,0,0,193,195,3,81,38,0,194,193,1,0,0,0,195,
        196,1,0,0,0,196,194,1,0,0,0,196,197,1,0,0,0,197,199,1,0,0,0,198,
        192,1,0,0,0,199,202,1,0,0,0,200,198,1,0,0,0,200,201,1,0,0,0,201,
        24,1,0,0,0,202,200,1,0,0,0,203,204,5,35,0,0,204,205,7,11,0,0,205,
        206,7,10,0,0,206,207,7,4,0,0,207,208,7,12,0,0,208,209,7,12,0,0,209,
        210,7,0,0,0,210,211,7,10,0,0,211,218,1,0,0,0,212,214,5,46,0,0,213,
        215,3,81,38,0,214,213,1,0,0,0,215,216,1,0,0,0,216,214,1,0,0,0,216,
        217,1,0,0,0,217,219,1,0,0,0,218,212,1,0,0,0,218,219,1,0,0,0,219,
        26,1,0,0,0,220,221,5,35,0,0,221,222,7,13,0,0,222,223,7,10,0,0,223,
        224,7,14,0,0,224,225,7,2,0,0,225,226,7,0,0,0,226,227,7,7,0,0,227,
        228,7,7,0,0,228,235,1,0,0,0,229,231,5,46,0,0,230,232,3,81,38,0,231,
        230,1,0,0,0,232,233,1,0,0,0,233,231,1,0,0,0,233,234,1,0,0,0,234,
        236,1,0,0,0,235,229,1,0,0,0,235,236,1,0,0,0,236,28,1,0,0,0,237,238,
        5,35,0,0,238,239,7,0,0,0,239,240,7,15,0,0,240,241,7,9,0,0,241,242,
        1,0,0,0,242,244,5,46,0,0,243,245,3,81,38,0,244,243,1,0,0,0,245,246,
        1,0,0,0,246,244,1,0,0,0,246,247,1,0,0,0,247,248,1,0,0,0,248,249,
        6,12,2,0,249,30,1,0,0,0,250,251,5,35,0,0,251,252,7,2,0,0,252,253,
        7,0,0,0,253,254,7,10,0,0,254,255,7,11,0,0,255,256,1,0,0,0,256,258,
        5,46,0,0,257,259,3,81,38,0,258,257,1,0,0,0,259,260,1,0,0,0,260,258,
        1,0,0,0,260,261,1,0,0,0,261,262,1,0,0,0,262,263,6,13,2,0,263,32,
        1,0,0,0,264,265,5,35,0,0,265,266,7,10,0,0,266,267,7,0,0,0,267,268,
        7,7,0,0,268,269,7,16,0,0,269,270,7,6,0,0,270,271,7,11,0,0,271,272,
        1,0,0,0,272,276,5,91,0,0,273,275,8,17,0,0,274,273,1,0,0,0,275,278,
        1,0,0,0,276,274,1,0,0,0,276,277,1,0,0,0,277,279,1,0,0,0,278,276,
        1,0,0,0,279,280,5,93,0,0,280,34,1,0,0,0,281,282,5,35,0,0,282,283,
        7,10,0,0,283,284,7,0,0,0,284,285,7,7,0,0,285,286,7,16,0,0,286,287,
        7,6,0,0,287,288,7,11,0,0,288,293,1,0,0,0,289,290,5,46,0,0,290,292,
        3,81,38,0,291,289,1,0,0,0,292,295,1,0,0,0,293,291,1,0,0,0,293,294,
        1,0,0,0,294,36,1,0,0,0,295,293,1,0,0,0,296,297,7,11,0,0,297,298,
        7,3,0,0,298,299,7,4,0,0,299,300,7,7,0,0,300,38,1,0,0,0,301,302,5,
        64,0,0,302,303,7,4,0,0,303,304,7,15,0,0,304,305,7,18,0,0,305,306,
        7,0,0,0,306,307,7,19,0,0,307,40,1,0,0,0,308,309,5,35,0,0,309,310,
        7,7,0,0,310,311,7,14,0,0,311,312,7,16,0,0,312,313,7,10,0,0,313,314,
        7,2,0,0,314,315,7,0,0,0,315,324,1,0,0,0,316,318,5,46,0,0,317,319,
        3,81,38,0,318,317,1,0,0,0,319,320,1,0,0,0,320,318,1,0,0,0,320,321,
        1,0,0,0,321,323,1,0,0,0,322,316,1,0,0,0,323,326,1,0,0,0,324,322,
        1,0,0,0,324,325,1,0,0,0,325,42,1,0,0,0,326,324,1,0,0,0,327,329,8,
        20,0,0,328,327,1,0,0,0,329,330,1,0,0,0,330,328,1,0,0,0,330,331,1,
        0,0,0,331,334,1,0,0,0,332,334,7,20,0,0,333,328,1,0,0,0,333,332,1,
        0,0,0,334,44,1,0,0,0,335,336,5,35,0,0,336,337,7,9,0,0,337,338,7,
        1,0,0,338,339,7,10,0,0,339,348,1,0,0,0,340,342,5,46,0,0,341,343,
        3,81,38,0,342,341,1,0,0,0,343,344,1,0,0,0,344,342,1,0,0,0,344,345,
        1,0,0,0,345,347,1,0,0,0,346,340,1,0,0,0,347,350,1,0,0,0,348,346,
        1,0,0,0,348,349,1,0,0,0,349,351,1,0,0,0,350,348,1,0,0,0,351,352,
        6,20,3,0,352,46,1,0,0,0,353,354,5,35,0,0,354,355,7,11,0,0,355,356,
        7,10,0,0,356,357,7,4,0,0,357,358,7,12,0,0,358,359,7,12,0,0,359,360,
        7,0,0,0,360,361,7,10,0,0,361,368,1,0,0,0,362,364,5,46,0,0,363,365,
        3,81,38,0,364,363,1,0,0,0,365,366,1,0,0,0,366,364,1,0,0,0,366,367,
        1,0,0,0,367,369,1,0,0,0,368,362,1,0,0,0,368,369,1,0,0,0,369,370,
        1,0,0,0,370,371,6,21,4,0,371,48,1,0,0,0,372,373,5,35,0,0,373,374,
        7,13,0,0,374,375,7,10,0,0,375,376,7,14,0,0,376,377,7,2,0,0,377,378,
        7,0,0,0,378,379,7,7,0,0,379,380,7,7,0,0,380,387,1,0,0,0,381,383,
        5,46,0,0,382,384,3,81,38,0,383,382,1,0,0,0,384,385,1,0,0,0,385,383,
        1,0,0,0,385,386,1,0,0,0,386,388,1,0,0,0,387,381,1,0,0,0,387,388,
        1,0,0,0,388,389,1,0,0,0,389,390,6,22,5,0,390,50,1,0,0,0,391,392,
        5,35,0,0,392,393,7,0,0,0,393,394,7,15,0,0,394,395,7,9,0,0,395,396,
        1,0,0,0,396,398,5,46,0,0,397,399,3,81,38,0,398,397,1,0,0,0,399,400,
        1,0,0,0,400,398,1,0,0,0,400,401,1,0,0,0,401,402,1,0,0,0,402,403,
        6,23,6,0,403,404,6,23,7,0,404,52,1,0,0,0,405,406,5,35,0,0,406,407,
        7,2,0,0,407,408,7,0,0,0,408,409,7,10,0,0,409,410,7,11,0,0,410,411,
        1,0,0,0,411,413,5,46,0,0,412,414,3,81,38,0,413,412,1,0,0,0,414,415,
        1,0,0,0,415,413,1,0,0,0,415,416,1,0,0,0,416,417,1,0,0,0,417,418,
        6,24,6,0,418,419,6,24,8,0,419,54,1,0,0,0,420,421,5,35,0,0,421,422,
        7,10,0,0,422,423,7,0,0,0,423,424,7,7,0,0,424,425,7,16,0,0,425,426,
        7,6,0,0,426,427,7,11,0,0,427,428,1,0,0,0,428,432,5,91,0,0,429,431,
        8,17,0,0,430,429,1,0,0,0,431,434,1,0,0,0,432,430,1,0,0,0,432,433,
        1,0,0,0,433,435,1,0,0,0,434,432,1,0,0,0,435,436,5,93,0,0,436,437,
        1,0,0,0,437,438,6,25,9,0,438,56,1,0,0,0,439,440,5,35,0,0,440,441,
        7,10,0,0,441,442,7,0,0,0,442,443,7,7,0,0,443,444,7,16,0,0,444,445,
        7,6,0,0,445,446,7,11,0,0,446,451,1,0,0,0,447,448,5,46,0,0,448,450,
        3,81,38,0,449,447,1,0,0,0,450,453,1,0,0,0,451,449,1,0,0,0,451,452,
        1,0,0,0,452,454,1,0,0,0,453,451,1,0,0,0,454,455,6,26,10,0,455,58,
        1,0,0,0,456,457,7,11,0,0,457,458,7,3,0,0,458,459,7,4,0,0,459,460,
        7,7,0,0,460,461,1,0,0,0,461,462,6,27,11,0,462,60,1,0,0,0,463,464,
        5,64,0,0,464,465,7,4,0,0,465,466,7,15,0,0,466,467,7,18,0,0,467,468,
        7,0,0,0,468,469,7,19,0,0,469,470,1,0,0,0,470,471,6,28,12,0,471,62,
        1,0,0,0,472,473,5,35,0,0,473,474,7,7,0,0,474,475,7,14,0,0,475,476,
        7,16,0,0,476,477,7,10,0,0,477,478,7,2,0,0,478,479,7,0,0,0,479,488,
        1,0,0,0,480,482,5,46,0,0,481,483,3,81,38,0,482,481,1,0,0,0,483,484,
        1,0,0,0,484,482,1,0,0,0,484,485,1,0,0,0,485,487,1,0,0,0,486,480,
        1,0,0,0,487,490,1,0,0,0,488,486,1,0,0,0,488,489,1,0,0,0,489,491,
        1,0,0,0,490,488,1,0,0,0,491,492,6,29,13,0,492,64,1,0,0,0,493,495,
        8,21,0,0,494,493,1,0,0,0,495,496,1,0,0,0,496,494,1,0,0,0,496,497,
        1,0,0,0,497,500,1,0,0,0,498,500,7,21,0,0,499,494,1,0,0,0,499,498,
        1,0,0,0,500,501,1,0,0,0,501,502,6,30,14,0,502,66,1,0,0,0,503,504,
        5,125,0,0,504,505,5,125,0,0,505,506,1,0,0,0,506,507,6,31,1,0,507,
        508,6,31,1,0,508,509,6,31,15,0,509,68,1,0,0,0,510,512,5,46,0,0,511,
        513,3,81,38,0,512,511,1,0,0,0,513,514,1,0,0,0,514,512,1,0,0,0,514,
        515,1,0,0,0,515,516,1,0,0,0,516,517,5,40,0,0,517,518,1,0,0,0,518,
        519,6,32,1,0,519,520,6,32,14,0,520,70,1,0,0,0,521,523,5,46,0,0,522,
        524,3,81,38,0,523,522,1,0,0,0,524,525,1,0,0,0,525,523,1,0,0,0,525,
        526,1,0,0,0,526,527,1,0,0,0,527,528,6,33,1,0,528,72,1,0,0,0,529,
        530,9,0,0,0,530,531,1,0,0,0,531,532,6,34,1,0,532,533,6,34,14,0,533,
        74,1,0,0,0,534,536,5,46,0,0,535,537,3,81,38,0,536,535,1,0,0,0,537,
        538,1,0,0,0,538,536,1,0,0,0,538,539,1,0,0,0,539,540,1,0,0,0,540,
        541,5,40,0,0,541,542,1,0,0,0,542,543,6,35,1,0,543,544,6,35,14,0,
        544,76,1,0,0,0,545,547,5,46,0,0,546,548,3,81,38,0,547,546,1,0,0,
        0,548,549,1,0,0,0,549,547,1,0,0,0,549,550,1,0,0,0,550,551,1,0,0,
        0,551,552,6,36,1,0,552,553,6,36,16,0,553,78,1,0,0,0,554,555,9,0,
        0,0,555,556,1,0,0,0,556,557,6,37,1,0,557,558,6,37,14,0,558,80,1,
        0,0,0,559,560,7,22,0,0,560,82,1,0,0,0,561,563,7,23,0,0,562,561,1,
        0,0,0,563,566,1,0,0,0,564,562,1,0,0,0,564,565,1,0,0,0,565,84,1,0,
        0,0,566,564,1,0,0,0,41,0,1,2,3,4,175,177,180,196,200,216,218,233,
        235,246,260,276,293,320,324,330,333,344,348,366,368,385,387,400,
        415,432,451,484,488,496,499,514,525,538,549,564,17,5,1,0,4,0,0,5,
        3,0,7,10,0,7,11,0,7,12,0,5,4,0,7,13,0,7,14,0,7,15,0,7,16,0,7,17,
        0,7,18,0,7,19,0,7,20,0,7,9,0,7,21,0
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!FrendsExpressionLexer.__ATN) {
            FrendsExpressionLexer.__ATN = new antlr.ATNDeserializer().deserialize(FrendsExpressionLexer._serializedATN);
        }

        return FrendsExpressionLexer.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(FrendsExpressionLexer.literalNames, FrendsExpressionLexer.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return FrendsExpressionLexer.vocabulary;
    }

    private static readonly decisionsToDFA = FrendsExpressionLexer._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}